import { Next } from '@securitize/ui-components';

export const getQuestionsNext = new Next('/faq', 'GET_QUESTIONS');
